import { render, staticRenderFns } from "./Billable.vue?vue&type=template&id=195c404a&scoped=true"
import script from "./Billable.vue?vue&type=script&lang=js"
export * from "./Billable.vue?vue&type=script&lang=js"
import style0 from "./Billable.vue?vue&type=style&index=0&id=195c404a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c404a",
  null
  
)

export default component.exports